<template>
  <div class="c-print">
    <div v-html="content"></div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import usePrint from '@/services/usePrint';

const { print } = usePrint();
const content = computed(() => print.content);
</script>
